import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { change, reset } from 'redux-form';
import vendorBannerTop from '../assets/images/CIIE_CO.gif';
import LandingPageHeader from '../Layouts/LandingPageHeader';
import ServiceProviderForm from './ServiceProviderForm';
import SuccessPopUp from '../common/SuccessPopUp';
import { uploadImages } from '../Services/Utils/CommonApis';
import { serviceProviderForm } from '../Services/Utils/ServiceProviderApis';
import { notifySet } from '../Services/Actions/CommonActions';
import { isEmpty } from '../Services/config/globals';
import {
  validateLink
} from '../common/helpers/form-validations';

function PartnerApplication() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleSuccessPopup = (value) => {
    setOpen(value);
    if (value === false) {
      navigate('/');
    }
  };

  const [uploadResponses, setUploadResponses] = useState([]);

  const [file, setFile] = useState([]);
  const [logoImage, setLogoImage] = useState([]);

  let logoId = '';

  const handleFileChange = ({ fileList: newFileList }) => setFile(newFileList);

  function getFields(input, field) {
    let output = null;
    for (let i = 0; i < input.length; ++i) output = input[i][field];
    return output;
  }

  const handleChangeLogo = ({ fileList: newFileList }) => {
    setLogoImage(newFileList);
  };

  const fileUpload = async (imageFile, type) => (
    new Promise((resolve) => {
      const imageData = getFields(imageFile, 'originFileObj');
      uploadImages({ file: imageData }).then((res) => {
        uploadResponses.push({
          file: res,
          type,
        });
        resolve(res);
      });
    })
  );

  const onButtonClick = async (formData) => {
    const ProductGuide = [];
    const promises = [fileUpload(logoImage, 'logo')];
    productGuides.forEach((guide) => {
      if (guide.type === 'link') {
        ProductGuide.push({
          linkUrl: guide.data,
          type: guide.type,
        });
      } else {
        promises.push(fileUpload(guide.data, 'product-guide'));
      }
    });

    Promise.all(promises).then(async () => {
      uploadResponses.forEach(async (response) => {
        if (response.type === 'logo') {
          logoId = response.file.view.fileId;
        } else {
          ProductGuide.push({
            fileView: {
              fileId: response.file.view.fileId,
            },
            type: 'file',
          });
        }
      });

      const serviceProviderFinalData = {
        categoryView: {
          id: formData.serviceCategory.id,
        },
        logoView: {
          fileId: logoId,
        },
        serviceProviderFileViews: ProductGuide,
        name: formData.serviceprovidername,
        estimatedPerks: formData.estimatedValue,
        website: formData.websiteURL,
        brief: formData.briefIntroduction,
        dealDetails: formData.dealDetail,
        redemptionProcess: formData.dealRedemptionProcess,
        redemptionLink: formData.dealRedemptionLink,
        eligibility: formData.eligibilityCriteria,
        remarks: formData.remark,
        pocName: formData.PoCName,
        pocEmail: formData.PoCEmailID,
        pocMobile: formData.phoneNumber,
        referrerName: formData.referrerName,
        hearAboutUs: formData.hearAboutUs.value,
        hearOther: formData.hearAboutUs.value === 'Others' ? formData.hearOther : ''
      };
      await serviceProviderForm(serviceProviderFinalData).then((response) => {
        const { hasError } = response;
        if (hasError === false) {
          setOpen(true);
          dispatch(reset('ServiceProviderForm'));
          setLogoImage([]);
          setFile([]);
          setProductGuides([]);
          setUploadResponses([]);
        } else if (hasError === true) {
          dispatch(notifySet({ type: 'error', message: response.message }));
        }
      });
    });
  };

  // add product guide
  const [openProductGuide, setOpenProductGuide] = useState(false);
  const productGuideUploadOptions = [
    { id: 1, label: 'File', value: 'file' },
    { id: 2, label: 'Link', value: 'link' }
  ];
  const [option, setOption] = useState(productGuideUploadOptions[0]);
  const [productGuides, setProductGuides] = useState([]);
  const [linkURL, setLinkURL] = useState('');

  const saveProductGuide = () => {
    if ((option.value === 'file' && file && file.length === 0)
        || (option.value === 'link' && !isEmpty(linkURL) && !validateLink(linkURL))) {
      return false;
    }
    const guide = {
      type: option.value,
      data: (option.value === 'file') ? file : linkURL,
      title: (option.value === 'file') ? file[0].name : linkURL
    };
    productGuides.push(guide);
    setProductGuides(productGuides);
    setOpenProductGuide(false);
    resetModal();
  };

  const resetModal = () => {
    dispatch(change('ServiceProviderForm', 'linkURL', ''));
    setLinkURL('');
    setFile([]);
    setOption(productGuideUploadOptions[0]);
  };

  const cancelProductGuide = () => {
    setOpenProductGuide(false);
    resetModal();
  };

  return (
    <div
      id="fullpage"
      className="fullpage-wrapper"
    >
      <LandingPageHeader />
      <div className="container-fluid banner-top-con mb-5">
        <div className="section">
          <div className="container-fluid banner-top-con">
            <div className="container  h-100">
              <div className="row  h-100">
                <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
                  <div className="banner-top text-center">
                    <img
                      alt=""
                      src={vendorBannerTop}
                      height="350"
                    />
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
                  <div className="caption-block title-bg-text">
                    <h1>
                      <span>PARTNER</span> <br />
                      <span>APPLICATION</span>
                    </h1>
                    <p>Offer partner perks to CIIE.COs thriving startup ecosystem and unlock engagement opportunities.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section">
          <div className="container-fluid ">
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <ServiceProviderForm
                    onButtonClick={onButtonClick}
                    buttonSaveText="Submit Application"
                    file={file}
                    logoImage={logoImage}
                    handleChangeLogo={handleChangeLogo}
                    handleFileChange={handleFileChange}
                    handleSuccessPopup={handleSuccessPopup}
                    saveProductGuide={saveProductGuide}
                    productGuideUploadOptions={productGuideUploadOptions}
                    option={option}
                    setOption={setOption}
                    linkURL={linkURL}
                    productGuides={productGuides}
                    open={openProductGuide}
                    setOpen={setOpenProductGuide}
                    setLinkURL={setLinkURL}
                    setProductGuides={setProductGuides}
                    cancelProductGuide={cancelProductGuide}
                    action="add"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <SuccessPopUp
          handleSuccessPopup={handleSuccessPopup}
          open={open}
          successMessage="you have successfully submitted your application"
        />
      </div>
    </div>
  );
}

export default PartnerApplication;
